import React, { useState, useEffect } from 'react';

interface CurrencyToggleProps {
  className?: string;
  onCurrencyChange?: (currency: 'MXN' | 'USD') => void;
}

export default function CurrencyToggle({ className = '', onCurrencyChange }: CurrencyToggleProps) {
  const [currency, setCurrency] = useState<'MXN' | 'USD'>(() => {
    // Leer preferencia guardada en localStorage
    const saved = localStorage.getItem('preferredCurrency');
    return (saved === 'USD' || saved === 'MXN') ? saved : 'MXN';
  });

  useEffect(() => {
    // Guardar preferencia en localStorage
    localStorage.setItem('preferredCurrency', currency);

    // Notificar al componente padre si existe callback
    if (onCurrencyChange) {
      onCurrencyChange(currency);
    }
  }, [currency, onCurrencyChange]);

  const handleToggle = () => {
    setCurrency(prev => prev === 'MXN' ? 'USD' : 'MXN');
  };

  return (
    <div className={`currency-toggle ${className}`}>
      <button
        onClick={handleToggle}
        className={`btn btn-sm ${currency === 'MXN' ? 'btn-primary' : 'btn-outline-primary'}`}
        style={{ minWidth: '80px', marginRight: '5px' }}
        type="button"
      >
        MXN $
      </button>
      <button
        onClick={handleToggle}
        className={`btn btn-sm ${currency === 'USD' ? 'btn-primary' : 'btn-outline-primary'}`}
        style={{ minWidth: '80px' }}
        type="button"
      >
        USD $
      </button>
    </div>
  );
}

// Hook para obtener la moneda preferida desde cualquier componente
export function usePreferredCurrency(): 'MXN' | 'USD' {
  const [currency, setCurrency] = useState<'MXN' | 'USD'>(() => {
    const saved = localStorage.getItem('preferredCurrency');
    return (saved === 'USD' || saved === 'MXN') ? saved : 'MXN';
  });

  useEffect(() => {
    // Escuchar cambios en localStorage (para sincronizar entre componentes)
    const handleStorageChange = () => {
      const saved = localStorage.getItem('preferredCurrency');
      if (saved === 'USD' || saved === 'MXN') {
        setCurrency(saved);
      }
    };

    window.addEventListener('storage', handleStorageChange);

    // Polling cada 500ms para detectar cambios en la misma pestaña
    const interval = setInterval(() => {
      const saved = localStorage.getItem('preferredCurrency');
      if ((saved === 'USD' || saved === 'MXN') && saved !== currency) {
        setCurrency(saved);
      }
    }, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [currency]);

  return currency;
}
